import { render, staticRenderFns } from "./SysProdutoAutocomplete.vue?vue&type=template&id=61be93da&scoped=true"
import script from "./SysProdutoAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysProdutoAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SysProdutoAutocomplete.vue?vue&type=style&index=0&id=61be93da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61be93da",
  null
  
)

export default component.exports